import { get } from 'lodash';

export const getLoading = state =>
  get(state, 'UpdateCEPCountsState.updateCEP.loading');

export const getSites = state =>
  get(state, 'UpdateCEPCountsState.updateCEP.sites');

export const getErrors = state =>
  get(state, 'UpdateCEPCountsState.updateCEP.error');

export const getSuccess = state =>
  get(state, 'UpdateCEPCountsState.updateCEP.success');



// WEBPACK FOOTER //
// ./src/pages/updatecepcounts/state/update/selectors.js